import Brands from '@/enums/Brands';

export const LOGO_SOURCE: Readonly<Record<Brands, string>> = {
	'ILC-US': '/logo_ILC-US.svg',
	MP: '/logo_MP.svg',
	OB: '/logo_OB.svg',
	MR: '/logo_IR.svg',
	ARO: '/logo_ARO.svg',
	'WV-US': '/logo_WV-US.svg',
	DT: '/logo_DT.svg',
	'ARO-NA': '/logo_ARO-NA.svg',
};

export const HERO_IMAGE_SOURCE: Readonly<Record<Brands, string>> = {
	'ILC-US': '',
	MP: '',
	OB: '',
	MR: '/hero_IR.jpg',
	ARO: '',
	'WV-US': '',
	DT: '',
	'ARO-NA': '',
};

export const BANNER_SOURCE: Readonly<Record<Brands, string>> = {
	'ILC-US': '/banner_ILC-US.jpg',
	MP: '/banner_MP.jpg',
	OB: '/banner_OB.jpg',
	MR: '/banner_IR.jpg',
	ARO: '/banner_ARO.jpg',
	'WV-US': '/banner_WV-US.jpg',
	DT: '/banner_DT.jpg',
	'ARO-NA': '/banner_ARO-NA.jpg',
};
